import { createSlice } from '@reduxjs/toolkit';

const initialState = true;

export const initSlice = createSlice({
  name: 'isInitializing',
  initialState,
  reducers: {
    completeInitialization: () => false,
  },
});

export const { completeInitialization } = initSlice.actions;
